/*
 * SPDX-License-Identifier: Apache-2.0
 *
 * The OpenSearch Contributors require contributions made to
 * this file be licensed under the Apache-2.0 license or a
 * compatible open source license.
 *
 * Modifications Copyright OpenSearch Contributors. See
 * GitHub history for details.
 */

import React, { Component } from 'react';
import PropTypes from "prop-types";
import { OuiComment } from '../../../../src/components/comment_list';
import { OuiButtonIcon } from '../../../../src/components/button';
import { OuiText } from '../../../../src/components/text';
import { OuiPopover } from '../../../../src/components/popover';
import { OuiContextMenuPanel, OuiContextMenuItem } from '../../../../src/components/context_menu';
var body = /*#__PURE__*/React.createElement(OuiText, {
  size: "s"
}, /*#__PURE__*/React.createElement("p", null, "This comment has custom actions available. See the upper right corner."));
class _default extends Component {
  state = {
    isPopoverOpen: false
  };
  togglePopover = () => {
    this.setState(prevState => ({
      isPopoverOpen: !prevState.isPopoverOpen
    }));
  };
  closePopover = () => {
    this.setState({
      isPopoverOpen: false
    });
  };
  render() {
    const {
      isPopoverOpen
    } = this.state;
    const customActions = <OuiPopover button={<OuiButtonIcon aria-label="Actions" iconType="gear" size="s" color="text" onClick={() => this.togglePopover()} />} isOpen={isPopoverOpen} closePopover={() => this.closePopover()} panelPaddingSize="none" anchorPosition="leftCenter">
        <OuiContextMenuPanel items={[<OuiContextMenuItem key="A" icon="pencil" onClick={() => {
        this.closePopover();
      }}>
              Edit
            </OuiContextMenuItem>, <OuiContextMenuItem key="B" icon="share" onClick={() => {
        this.closePopover();
      }}>
              Share
            </OuiContextMenuItem>, <OuiContextMenuItem key="C" icon="copy" onClick={() => {
        this.closePopover();
      }}>
              Copy
            </OuiContextMenuItem>]} />
      </OuiPopover>;
    return <div>
        <OuiComment username="janed" event="added a comment" actions={customActions} timestamp="Jan 1, 2020">
          {body}
        </OuiComment>
      </div>;
  }
}
_default.propTypes = {
  className: PropTypes.string,
  "aria-label": PropTypes.string,
  "data-test-subj": PropTypes.string
};
export { _default as default };
try {
  commentactions.__docgenInfo = {
    tags: {},
    filePath: '/codebuild/output/src3672379046/src/src-docs/src/views/comment/comment_actions.tsx',
    description: '',
    displayName: 'commentactions',
    methods: [],
    props: {
      className: {
        defaultValue: null,
        description: '',
        name: 'className',
        parent: {
          fileName: 'src/node_modules/@types/react/index.d.ts',
          name: 'HTMLAttributes'
        },
        declarations: [{
          fileName: 'src/node_modules/@types/react/index.d.ts',
          name: 'HTMLAttributes'
        }, {
          fileName: 'src/src/components/common.ts',
          name: 'CommonProps'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      'aria-label': {
        defaultValue: null,
        description: 'Defines a string value that labels the current element.\n' + '@see aria-labelledby.',
        name: 'aria-label',
        parent: {
          fileName: 'src/node_modules/@types/react/index.d.ts',
          name: 'AriaAttributes'
        },
        declarations: [{
          fileName: 'src/node_modules/@types/react/index.d.ts',
          name: 'AriaAttributes'
        }, {
          fileName: 'src/src/components/common.ts',
          name: 'CommonProps'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      'data-test-subj': {
        defaultValue: null,
        description: '',
        name: 'data-test-subj',
        parent: {
          fileName: 'src/src/components/common.ts',
          name: 'CommonProps'
        },
        declarations: [{
          fileName: 'src/src/components/common.ts',
          name: 'CommonProps'
        }],
        required: false,
        type: {
          name: 'string'
        }
      }
    },
    extendedInterfaces: ['HTMLAttributes', 'AriaAttributes', 'DOMAttributes', 'CommonProps']
  };
} catch (e) {}